import { _createDiet, _dietTemplate } from "../constants/api";

export const createDiet = async (data) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));
    const token = userData?.token;

    if (!token) {
      alert("Token not found");
    }

    const res = await fetch(`${_createDiet}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        clientid: "e0ce9cb8-430e-4148-b562-b8833cc9fa0b",
      },
      body: JSON.stringify(data),
    })
    if(res.ok){
      return res.json()
    } else {
      throw new Error('Error creating diet')
    }
  } catch (error) {
    // alert("Error occured in the create diet api ==> ", error);
    return error
  }
};

export const getAllDietTemplate = async (data) => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const token = userData?.token;

  if (!token) {
    alert("Token not found");
  }

  const response = await fetch(`${_dietTemplate}/659d6688a715b2b01fce16e8`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  })
  if (!response.ok) {
    alert('Network response was not ok');
  }
  const res = await response.json();
  return res;
};

export const deleteDietTemplate = async (id) => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const token = userData?.token;

  if (!token) {
    alert("Token not found");
  }

  const response = await fetch(`${_dietTemplate}/${id}`, {
    method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        clientid: "e0ce9cb8-430e-4148-b562-b8833cc9fa0b",
      },
  })
  if (!response.ok) {
    alert('Network response was not ok');
  }
  const res = await response.json();
  return res;
};

export const createDietPlanTemplate = async (data) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));
    const token = userData?.token;

    if (!token) {
      alert("Token not found");
    }

    await fetch(`${_dietTemplate}/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        clientid: "e0ce9cb8-430e-4148-b562-b8833cc9fa0b",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const responseJSON = await response.json();
      return responseJSON;
    });
  } catch (error) {
    alert("Error occured in the create diet plan template api ==> ", error);
  }
};
